import { render, staticRenderFns } from "./addTemplateActivity.vue?vue&type=template&id=7d87203b&scoped=true"
import script from "./addTemplateActivity.vue?vue&type=script&lang=js"
export * from "./addTemplateActivity.vue?vue&type=script&lang=js"
import style0 from "./addTemplateActivity.vue?vue&type=style&index=0&id=7d87203b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d87203b",
  null
  
)

export default component.exports